import { render, staticRenderFns } from "./SignWidgetButtons.vue?vue&type=template&id=4045296f&"
import script from "./SignWidgetButtons.vue?vue&type=script&lang=js&"
export * from "./SignWidgetButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports